import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Tab3Table1 from "./Tab3Table1";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
const Tab3 = ({
  ItemCode,
  Default_Purchase_Unit_of_Measure,
  Safety_Stock,
  Minimum_Order_Qty,
  Lead_Time_in_days,
  Allow_Purchase,
  Is_Customer_Provided_Item,
  Country_of_Origin,
  CustomsTariffNumber,
  setselected_item_supplier_data,
  selected_item_supplier_data,
  Delivered_by_Supplier
}) => {

  return (
    <>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Purchasing Details</p>
        </div>


        <div className="col-6 ">
          <div className="mb-3">
            <Input label="Default Purchase Unit of Measure" readOnly value={Default_Purchase_Unit_of_Measure.select_Default_Purchase_Unit_of_Measure} style={{ height: '38px' }} />





          </div>
        </div>


        <div className="col-6 ">
          <div className="mb-3">
            <Input
              readOnly
              id="Safety_Stock"
              label="Safety Stock"
              style={{ height: "30px", }}
              value={Safety_Stock.Safety_Stock}
              onChange={(e) => Safety_Stock.setSafety_Stock(e.target.value)}
            />

          </div>
        </div>
        <div className="col-6 ">
          <div className="mb-1">
            <Input
              readOnly
              id="Minimum_Order_Qty"
              label="Minimum Order Qty"
              style={{ height: "30px", }}
              value={Minimum_Order_Qty.Minimum_Order_Qty}
              onChange={(e) => Minimum_Order_Qty.setMinimum_Order_Qty(e.target.value)}
            />
            <p style={{
              paddingLeft: '14px',
              paddingRight: '14px',
              fontWeight: 400,
              fontSize: '9px',
              letterSpacing: '0',
              color: '#00000099', fontFamily: 'Roboto, sans-serif',
            }} >
              Minimum quantity should be as per Stock UOM
            </p>
          </div>


        </div>
        <div className="col-6">
          <div className="mb-1">
            <Input
              readOnly
              id="Lead_Time_in_days"
              label="Lead Time in days"
              style={{ height: "30px", }}
              value={Lead_Time_in_days.Lead_Time_in_days}
              onChange={(e) => Lead_Time_in_days.setLead_Time_in_days(e.target.value)}
            />
            <p style={{
              paddingLeft: '14px',
              paddingRight: '14px',
              fontWeight: 400,
              fontSize: '9px',
              letterSpacing: '0',
              color: '#00000099', fontFamily: 'Roboto, sans-serif',
            }} >
              Average time taken by the supplier to deliver
            </p>
          </div>
        </div>






        <div className="col-6 ">
          <div className="mb-3">

            <Checkbox
              disabled={true}
              id="Allow_Purchase"
              label="Allow Purchase"
              value={Allow_Purchase?.Allow_Purchase || false}
              onChange={(val) => Allow_Purchase?.setAllow_Purchase?.(val)}
            />

          </div>
        </div>


        <div className="col-6 ">
          <div className="mb-3">

            <Checkbox
              disabled={true}
              id="Is_Customer_Provided_Item"
              label="Is Customer Provided Item"
              value={Is_Customer_Provided_Item?.Is_Customer_Provided_Item || false}
              onChange={(val) => Is_Customer_Provided_Item?.setIs_Customer_Provided_Item?.(val)}
            />

          </div>
        </div>


      </div>



      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >

        <div className="col-12">
          <p className="boxLabel m-0">Supplier Details</p>
        </div>
        <div className="col-4 ">
          <div className="mb-3">

            <Checkbox
              disabled={true}
              id="Delivered_by_Supplier"
              label="Delivered by Supplier (Drop Ship)"
              value={Delivered_by_Supplier?.Delivered_by_Supplier || false}
              onChange={(val) => Delivered_by_Supplier?.setDelivered_by_Supplier?.(val)}
            />

          </div>
        </div>

        <Tab3Table1 setselected_item_supplier_data={setselected_item_supplier_data} selected_item_supplier_data={selected_item_supplier_data} />
      </div>



      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Foreign Trade Details</p>
        </div>
        <div className="col-6 ">
          <div className="mb-3">
            <Input label="Country of Origin" readOnly value={Country_of_Origin.select_Country_of_Origin} style={{ height: '38px' }} />
          </div>
        </div>
        <div className="col-6 ">
          <div className="mb-3">
            <Input label="Customs Tariff Number" readOnly value={CustomsTariffNumber.select_CustomsTariffNumber} style={{ height: '38px' }} />

          </div>
        </div>

      </div>

        <div>
              <ActivityCard doctype={'Item'} docname={ItemCode.ItemCode} />
          </div>




    </>
  );
};

export default Tab3;
